import { useState } from "react";
import LoginForm from "./Forms/Login";
import RegisterForm from "./Forms/Register";
import { useTranslation } from "react-i18next";
import "./auth.css";

function LoginPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("login");

  return (
    <div className="auth-screen" dir="rtl">
      <div className="auth-content">

        <div className="auth-logo">
          <img src={require('../../assets/images/logo.png')} alt="عقاراتي" />
          <p className="auth-logo__app-name">عقاراتي</p>
          <p className="auth-logo__tagline">{t('auth.description')}</p>
        </div>

        <div className="auth-tab-switch">
          <button
            className={'auth-tab-switch__btn' + (activeTab === 'login' ? ' auth-tab-switch__btn--active' : '')}
            onClick={() => setActiveTab('login')}
          >
            {t('auth.tabs.login.title')}
          </button>
          <button
            className={'auth-tab-switch__btn' + (activeTab === 'register' ? ' auth-tab-switch__btn--active' : '')}
            onClick={() => setActiveTab('register')}
          >
            {t('auth.tabs.register.title')}
          </button>
        </div>

        {activeTab === 'login' ? <LoginForm /> : <RegisterForm />}

      </div>
    </div>
  );
}

export default LoginPage;
